import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

import "./style/chips.scss";
import "./style/code-editor.scss";
import "./style/index.scss";
import "./style/navigation.scss";
import "./style/table.scss";
import "./style/_modals.scss";
import "./style/bootstrap-theme.scss";
import "./style/dark_mode.scss";
import "./style/highlight.js.theme.scss";
import Layout from "./layout.tsx";
import { msalInstance } from "./components/lib/auth/msalInstance.ts";

msalInstance
  .initialize()
  .then(() => {
    return msalInstance.handleRedirectPromise();
  })
  .then(() => {
    ReactDOM.render(
      <React.StrictMode>
        <Layout />
      </React.StrictMode>,
      document.getElementById("root"),
    );
  })
  .catch((error) => {
    console.error("MSAL Initialization Error:", error);
  });
